import styled from "styled-components/macro";
import { PAGE_CONTAINER_MAX_WIDTH } from "../constants";

const DivPageContainer = styled.div`
  margin: auto;
  max-width: ${PAGE_CONTAINER_MAX_WIDTH};
`;

export default DivPageContainer;
